import { Link } from "react-router-dom";
import "./button.css";

/**
 * The only button on the site.
 *
 * Renders whichever element actually matches the behaviour — an anchor when it
 * navigates, a button when it acts — so keyboard support and assistive
 * semantics come for free rather than needing them bolted on.
 */
export default function Button({
  variant = "primary",
  size = "md",
  href,
  to,
  children,
  className = "",
  ...rest
}) {
  const classes = `btn btn--${variant} btn--${size} ${className}`.trim();

  if (href) {
    return (
      <a
        className={classes}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        {...rest}
      >
        {children}
      </a>
    );
  }

  if (to) {
    return (
      <Link className={classes} to={to} {...rest}>
        {children}
      </Link>
    );
  }

  return (
    <button className={classes} type="button" {...rest}>
      {children}
    </button>
  );
}
